<template>
  <v-dialog 
    max-width="350" 
    v-model="confirmWindow"
    @click:outside="closeWindow"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline">Удалить {{ objName }}?</v-card-title>
      
      <v-card-text>
        <v-alert
          dense
          outlined
          type="error"
          :value="!!error"
          transition="scale-transition"
        >{{ error }}</v-alert>

        <slot></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn 
          color="blue darken-1" 
          text 
          @click="closeWindow"
          :disabled="loading"
        >Отмена</v-btn>

        <v-btn
          color="blue darken-1"
          text
          @click="deleteObj"
          :disabled="loading"
          :loading="loading"
        >Удалить</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'delete-button',

  props: {
    id: '',
    objName: String,
    deleteFunc: Function,
    funcParam: String
  },

  data() {
    return {
      loading: false,
      error: '',
      confirmWindow: false,
    };
  },

  methods: {
    deleteObj() {
      this.loading = true;

      this.deleteFunc(...(this.funcParam ? [this.funcParam, this.id] : [this.id]))
      .then(result => {
        this.$store.dispatch('showMessage', result.message);
        this.closeWindow();
      })
      .catch(err => {
        this.error = err.message;
      })
      .finally(() => {
        this.loading = false;
      });
    },

    closeWindow() {
      this.error = '';
      this.confirmWindow = false;
    },
  },
}
</script>